export default "__VITE_ASSET__cCywB0TU__"